module.exports = __webpack_public_path__ + "static/img/1.d09d78b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/1.png
// module id = SGiD
// module chunks = 0